import React from 'react';

function GameOver({ moves, matchedPairs, time, onRestart }) {
    return (
        <div className="gameover-container">
            <h2>Bravo, vous avez gagné !</h2>

            <p>
                Coups joués : <strong>{moves}</strong>
            </p>
            <p>
                Temps : <strong>{time} sec</strong>
            </p>

            <button className="gameover-btn" onClick={onRestart}>
                Rejouer
            </button>
        </div>
    );
}

export default GameOver;
